<div class="userDetails">
  <div>{{ store.$account().email }}</div>
  <br />
  <div class="userDetails__addresses">
    @if (requiresShippingAddress()) {
      <div>
        <strong>{{ 'shipping-address' | translate }}</strong>
        @for (line of formattedShippingAddress(); track line) {
          <div>
            {{ line }}
          </div>
        }
      </div>
    }
    @if (requiresBillingAddress()) {
      <div>
        <strong>{{ 'billing-address' | translate }}</strong>
        @for (line of formattedBillingAddress(); track line) {
          <div>
            {{ line }}
          </div>
        }
      </div>
    }
  </div>
</div>
